/**
 * @generated SignedSource<<16b9842995f5e9f759432ec636149979>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EmployeeScheduleEditScheduleTypesAssignTeamQuery$variables = Record<PropertyKey, never>;
export type EmployeeScheduleEditScheduleTypesAssignTeamQuery$data = {
  readonly store: {
    readonly employeeScheduleTypes: ReadonlyArray<{
      readonly assignedTeams: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly id: string;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"EmployeeScheduleEditScheduleTypesAssignTeam">;
  };
};
export type EmployeeScheduleEditScheduleTypesAssignTeamQuery = {
  response: EmployeeScheduleEditScheduleTypesAssignTeamQuery$data;
  variables: EmployeeScheduleEditScheduleTypesAssignTeamQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "EmployeeScheduleEditScheduleTypesAssignTeamQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EmployeeScheduleEditScheduleTypesAssignTeam"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EmployeeScheduleType",
            "kind": "LinkedField",
            "name": "employeeScheduleTypes",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "assignedTeams",
                "plural": true,
                "selections": [
                  (v0/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "EmployeeScheduleEditScheduleTypesAssignTeamQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EmployeeScheduleType",
            "kind": "LinkedField",
            "name": "employeeScheduleTypes",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "assignedTeams",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "icon",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "eb675c6659983a16ca2201edd9b39f8c",
    "id": null,
    "metadata": {},
    "name": "EmployeeScheduleEditScheduleTypesAssignTeamQuery",
    "operationKind": "query",
    "text": "query EmployeeScheduleEditScheduleTypesAssignTeamQuery {\n  store {\n    ...EmployeeScheduleEditScheduleTypesAssignTeam\n    employeeScheduleTypes {\n      id\n      assignedTeams {\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment EmployeeScheduleEditScheduleTypesAssignTeam on Store {\n  employeeScheduleTypes {\n    id\n    ...EmployeeScheduleEditScheduleTypesAssignTeam_scheduleType\n  }\n}\n\nfragment EmployeeScheduleEditScheduleTypesAssignTeam_scheduleType on EmployeeScheduleType {\n  id\n  title\n  color\n  assignedTeams {\n    id\n    color\n    name\n    icon\n  }\n}\n"
  }
};
})();

(node as any).hash = "ef0b4c906761f4c3c1a7f323b0375a53";

export default node;
